export default __webpack_public_path__ + "static/media/miguel-lopes-14.f8072782.jpg";